// extracted by mini-css-extract-plugin
export var contactMethods = "LocationDetails-module--contactMethods--f010c";
export var container = "LocationDetails-module--container--b5287";
export var content = "LocationDetails-module--content--d5df3";
export var directions = "LocationDetails-module--directions--0f01c";
export var metaCol1 = "LocationDetails-module--metaCol1--b284a";
export var metaCol2 = "LocationDetails-module--metaCol2--6f91a";
export var openingTimesList = "LocationDetails-module--openingTimesList--1c5f8";
export var services = "LocationDetails-module--services--b70ad";